'use strict';

const Slide = require('./slide');
const $ = require('jquery');
const lang = require('../lang');
const template = require('../templates/sign-slide.hbs');
const printTemplate = require('../templates/print/print-1.hbs');
const printHTMLTemplate = require('../templates/print/print-2.hbs');
const printqrHTMLTemplate = require('../templates/print/print-qr.hbs');
const printTharmalHTMLTemplate = require('../templates/print/print-tharmal.hbs');
const printLandscapeHTMLTemplate = require('../templates/print/print-landscape.hbs');
const printKIOSKLandscapeHTMLTemplate = require('../templates/print/print-kiosk-landscape.hbs');
const Fun = require('../fun');
const Modal = require('../modal');

module.exports = class extends Slide {
  constructor({location, photoHost, moduleUniqueIdentifier, uniqueIdentifierLabel}, context = {}) {
    context = $.extend({}, {title: lang.get('sign_title')}, context);
    super(template, context);

    this._location = location;
    this._photoHost = photoHost;
    this._moduleUniqueIdentifier = moduleUniqueIdentifier;
    this._uniqueIdentifierLabel = uniqueIdentifierLabel;
    //noinspection JSUnresolvedVariable
    _idletimer = _mainidletimer;
    this._pdfdoc = '';
    this._qrcode = '';
    this._printertype = '';   
    this.domEvents = {
      'click #sign-slide-form-button': '_backToFormSlide',
      'click #slideshow-btn-print': '_storeSignAndPrint',
      'click #slideshow-btn-popup': '_storeSignAndPopup',
      'click #pul-link': '_showPul',
      //'mousemove': '_resetIdleTimer',
      'keydown':'_resetIdleTimer',
      'click': '_resetIdleTimer'
    };

    this.on('beforeEnter', () => {
      this._renderFormData();
      this._renderPrint();
    });
    if(this._location.module_kiosk){
      if(this._location.printout_landscape_mode){
        this.on('beforeEnter', () => {
          this._renderLandscapeHTMLFormData();
          this._renderTharmalHTMLFormData();
          this._renderHTMLPrint();
        });
      }else{
        this.on('beforeEnter', () => {
          this._renderHTMLFormData();
          this._renderTharmalHTMLFormData();
          this._renderHTMLPrint();
        });
      }      
    }else{
      //for landscape print
      if(this._location.printout_landscape_mode){
        this.on('beforeEnter', () => {
          this._renderLandscapeHTMLFormData();
          this._renderLandscapeHTMLPrint();
        });
      }
    }
    
    this.on('beforeEnter', this._delayAcceptButton);
    this.on('afterLeave', () => $('#slideshow-btn-print').spinner('stop'));
    this.on('afterLeave', () => $('#slideshow-btn-popup').spinner('stop'));
    this.on('afterEnter', this._stopIdleTimer);
    this.on('afterEnter', this._countdown);
    this.on('afterLeave', this._disableAcceptButton);
  }

  // DOM EVENTS

  _backToFormSlide() {
    //noinspection JSUnresolvedVariable
    _idletimer = _mainidletimer;
    clearInterval(_idleintervalHandler);
    window.location.hash = '/' + this._slideshow.findIndex(require('./form-slide'));
  }

  _clearLocalStorage() {
    localStorage.removeItem("breathalyzer_check");
    localStorage.removeItem("checkin_time");
    localStorage.removeItem("main_location_id");
    localStorage.removeItem("luprefnr");
    localStorage.removeItem('unique_identification_number');
    localStorage.removeItem('custom_signature_value');
    localStorage.removeItem('phone_no');
    localStorage.removeItem('regnr');
    localStorage.removeItem('unique_identification_label');
    localStorage.removeItem('contact_to_visit');
  }

  _storeSignAndPrint() {
    // return if printout_directly_after_form_slide active
    if(this._location.printout_directly_after_form_slide){
      return true;
    }
    //noinspection JSUnresolvedVariable
    _idletimer = _mainidletimer;
    clearInterval(_idleintervalHandler);
    if (this.$el.find('#slideshow-btn-print').hasClass('slideshow-btn-disabled'))
      return false;
    var breathalyzer_check = localStorage.getItem("breathalyzer_check") || 0;
    var main_location_id = localStorage.getItem("main_location_id") || 0;
    var luprefnr = localStorage.getItem("luprefnr") || null;
    var contact_to_visit = localStorage.getItem("contact_to_visit") || null;

    var start_time = localStorage.getItem("checkin_time");
    var end_time = new Date().getTime();
    var millis = end_time - start_time;
    var checkin_time = (millis / 1000).toFixed(0);
    var refnr = '';
    const trackId = this._slideshow.getTrackId();
    $('#slideshow-btn-print').spinner('start');
    $.ajax({
      method: 'POST',
      url: 'slideshow/sign',
      data: $.extend({}, this._slideshow.getFormData(), {
        subLocationId: this._slideshow.getSublocationId(),
        trackId: trackId,
        readSlideshow: !this._slideshow.hasSkipped,
        breathalyzer_check: breathalyzer_check,
        module_kiosk: this._location.module_kiosk,
        main_location_id: main_location_id,
        checkin_time: checkin_time,
        printer_type: this._printertype,
        slideshow_html: this._pdfdoc[0].outerHTML,
        isLandscape: this._location.printout_landscape_mode,
        luprefnr: luprefnr,
        contact_to_visit: contact_to_visit
      }),
      success: (res) => {
        refnr = res;
        this._clearLocalStorage();
        if(this._location.module_kiosk){
          $.ajax({
            method: 'GET',
            url: 'http://localhost:5000/print-pdf?link='+refnr,
            success: (res) => {
               $.ajax({
                method: 'POST',
                url: '/kiosk/delete-pdf',
                data: { 'file': refnr },
                success: (res) => {
                }
              });
            },
            error: function(){
              $.ajax({
                method: 'POST',
                url: '/kiosk/delete-pdf',
                data: { 'file': refnr },
                success: (res) => {
                }
              });
            },
            timeout: 5000
          });
        }
      }
    });

    if(!this._location.module_kiosk && this._location.printout){
      //Printout optional
      let printout_optional = false;
      if (this._slideshow._location.printout_optional_to_all === 1) {
        printout_optional = true;
      } else if (this._slideshow.getSublocationId() && this._slideshow._sublocation.printout_optional_to_all === 1) {
        printout_optional = true;
      } else if (this._slideshow.hasSkipped) {
        if (this._slideshow._location.printout_optional === 1) {
          printout_optional = true;
        } else if (this._slideshow.getSublocationId() && this._slideshow._sublocation.printout_optional === 1) {
          printout_optional = true;
        }
      }
    
      if (printout_optional) {
        new Modal({
          titleText: lang.get('skip_print_title'),
          bodyText: " ",
          cancelBtnText: lang.get('skip_print_cancel'),
          submitBtnText: lang.get('skip_print_submit'),
          sizeClass: '',
          onSubmit: () => {
            window.print();
          }
        });
      } else {
      window.print();
      }
    }
  }

  _storeSignAndPopup() {
     // return if printout_directly_after_form_slide active
     if(this._location.printout_directly_after_form_slide){
      return true;
    }
    //noinspection JSUnresolvedVariable
    _idletimer = _mainidletimer;
    clearInterval(_idleintervalHandler);
    if (this.$el.find('#slideshow-btn-popup').hasClass('slideshow-btn-disabled'))
      return false;
    var breathalyzer_check = localStorage.getItem("breathalyzer_check") || 0;
    var main_location_id = localStorage.getItem("main_location_id") || 0;
    var luprefnr = localStorage.getItem("luprefnr") || null;
    var contact_to_visit = localStorage.getItem("contact_to_visit") || null;
    const trackId = this._slideshow.getTrackId();
    var start_time = localStorage.getItem("checkin_time");
    var end_time = new Date().getTime();
    var millis = end_time - start_time;
    var checkin_time = (millis / 1000).toFixed(0);
    $.ajax({
      method: 'POST',
      url: 'slideshow/sign',
      data: $.extend({}, this._slideshow.getFormData(), {
        subLocationId: this._slideshow.getSublocationId(),
        trackId: trackId,
        readSlideshow: !this._slideshow.hasSkipped,
        breathalyzer_check: breathalyzer_check,
        module_kiosk: this._location.module_kiosk,
        main_location_id: main_location_id,
        checkin_time: checkin_time,
        printer_type: 'A4',
        slideshow_html: this._pdfdoc[0].outerHTML,
        isLandscape: this._location.printout_landscape_mode,
        luprefnr: luprefnr,
        contact_to_visit: contact_to_visit
      })
    }).done((response) => {
      this._clearLocalStorage();
      location.href = '/print-pdf/' + response;
    });

    $('#slideshow-btn-popup').spinner('start');
  }

  _showPul(e) {
    //noinspection JSUnresolvedVariable
    _idletimer = _mainidletimer;
    e.preventDefault();
    new Modal({
      titleText: lang.get('pul_modal_title'),
      bodyText: '<p>' + lang.get('pul').replace(/(\r\n)+|\r+|\n+/g, '</p><p>') + '</p>',
      submitBtnText: lang.get('form_modal_button'),
      sizeClass: ''
    });
  }

  // SLIDE EVENTS

  _renderPrint() {
    let $printContainer = $('#print-container').html(printTemplate($.extend({}, this._location, this._slideshow, {photoHost: this._photoHost})));
    const formData = this.$el.find('#sign-slide-form-data').html(); // make sure _renderFormData is called before _renderPrint, or this fails
    $printContainer.find('#print-form-data').html(formData);

    //Ajax call to get QR code
    var qr_code = '';
    if (this._location.module_qr_code === 1) {
      $.ajax({
        method: 'POST',
        url: 'slideshow/getqrcode',
        async: false,
        dataType: 'json',
        data: {
          'locationId': this._locationId,
          'name': $('#form_field_name').val(),
          'lpnumber': $('#form_field_registration_number').val()
        },
        success: function (res) {
          qr_code = res;
          qr_code.qr_code_instructions = lang.get('qr_code_instructions');
          $('#qrcode').html('<img style="padding: 20px 10px;" src="' + res.qrcodeimage + '">');
          $('#qrcode_text').val(res.qrcode);
          $('#qrcode_instruction').html('<h3>'+lang.get('qr_code_instructions')+'</h3>');
        },
      });
    }
    this._qrcode = qr_code;
    this._pdfdoc = $printContainer;
    var trackId = this._slideshow.getTrackId();
    //Ajax Call to get the document and its length
    var url22 = window.location.toString();
    var res = url22.split('#');
    var result = "";
    var urlbreak = res[0].split("/");

    if(trackId == null || trackId == undefined) {
       trackId = this._slideshow.getSublocationId();
    }

    if (urlbreak[urlbreak.length - 1] === 'slideshow') {
      var urltocall = res[0] + '/getdocument?trackid='+trackId;
    }
    if (urlbreak[urlbreak.length - 1] === '') {
      var urltocall = res[0] + 'getdocument?trackid='+trackId;
    }

    $.ajax({
      async: false,
      type: "GET",
      url: urltocall,
      cache: false,
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      data: {},
      success: function (response) {


        if (response.document_name !== '') {
          var removeEmptypage = 0;
          var ii = 1;
          $.each(response, function (key, value) {

            var url = value.document_name;

// Loaded via <script> tag, create shortcut to access PDF.js exports.
            var pdfjsLib = window['pdfjs-dist/build/pdf'];
            pdfjsLib.workerSrc = "/path/to/pdf.worker.js";
            pdfjsLib.getDocument(url).promise
              .then(function (pdf) {

                // Get div#container and cache it for later use
                var d1 = document.getElementById('container2');
                d1.insertAdjacentHTML('afterend', '<div id="container' + ii + '"></div>');
                var container = document.getElementById("container" + ii);

                // Loop from 1 to total_number_of_pages in PDF document

                for (var i = 1; i <= pdf.numPages; i++) {
                  // Get desired page
                  pdf.getPage(i).then(function (page) {

                    var scale = 1.15;
                    var viewport = page.getViewport(scale);
                    //viewport.height = 792;
                    //viewport.width = 900;
                    var div = document.createElement("div");

                    // Set id attribute with page-#{pdf_page_number} format
                    div.setAttribute("id", "page-" + (page.pageIndex + 1));

                    // This will keep positions of child elements as per our needs
                    div.setAttribute("style", "position: relative");

                    // Append div within div#container
                    container.appendChild(div);

                    // Create a new Canvas element
                    var canvas = document.createElement("canvas");

                    // Append Canvas within div#page-#{pdf_page_number}
                    div.appendChild(canvas);

                    var context = canvas.getContext('2d');
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;

                    var renderContext = {
                      canvasContext: context,
                      viewport: viewport
                    };

                    // Render PDF page
                    page.render(renderContext);

                  });
                }
              });


            ii++;
          });


        }
      }
    });
  }

  // render form data in 2 columns, in the same layout as used for the form.
  // i.e. |1|2|
  //      |3|4|
  _renderFormData() {
    let ret = '';
    let dl1 = '<dl class="dl-horizontal form-data-dl1">';
    let dl2 = '<dl class="dl-horizontal form-data-dl2">';
    // Mobile sign slide only has one column and hence it needs a different order
    let mobile = '<dl class="dl-horizontal">';
    let isEmpty = true;
    const formData = this._slideshow.getFormData();

    let i = 0;
    Object.keys(formData).forEach(field => {
      if (field === "form_field_id_scan") return;
      if(!this._moduleUniqueIdentifier){
        if (field === "unique_identification_number") return;
      }
      if (field === 'qrcode') return;
      if (field === 'label_location_id') return;
      if (field === 'label_exist_code') return;
      if (field === 'unique_identifier_label_exist') return;
      if (field === 'form_field_signature_id') return;
      const value = formData[field];
      if (isEmpty && value !== '') isEmpty = false;
      let label_name = '';
      if(this._moduleUniqueIdentifier && field === 'unique_identification_number'){
        if($("#unique_identifier_label_exist").val() == 1){
          return;
        }
        label_name = lang.get(this._uniqueIdentifierLabel);
      }else{
        label_name = lang.get(field);
      }
      const item = '<dt>' + label_name + '</dt><dd>' + value + '</dd>';
      mobile += item;
      if (i % 2 === 0)
        dl1 += item;
      else
        dl2 += item;
      i += 1;
    });

    dl1 += '</dl>';
    dl2 += '</dl>';
    mobile += '</dl>';

    if (isEmpty) {
      ret = '<p>' + lang.get('sign_empty_form') + '</p>';
      mobile = ret;
    }
    else
      ret = dl1 + dl2;

    this.$el.find('#sign-slide-form-data').html(ret);
    this.$el.find('#sign-slide-form-data-mobile').html(mobile);
  }

  _resetIdleTimer() {
    $('.idle-timer-container').hide();
    //noinspection JSUnresolvedVariable
    _idletimer = _mainidletimer;
  }

  _countdown() {
    //noinspection JSUnresolvedVariable
    _idletimer = _mainidletimer;
    $('.idle-timer-container').hide();
    const $domTimer = this.$el.find('#idle-timer');
    //noinspection JSUnresolvedVariable
    _idleintervalHandler = setInterval(() => {
      //noinspection JSUnresolvedVariable
      _idletimer -= 1;
      if (_idletimer <= 30) {
        $('.idle-timer-container').show();
        $domTimer.html(_idletimer);
      }
      if (_idletimer === 0) {
        this._slideshow._clearForm();
        $('#modal').modal('hide');
        clearInterval(_idleintervalHandler);
        //noinspection JSUnresolvedVariable
        _idletimer = _mainidletimer;
        $('.idle-timer-container').hide();
        window.location.hash = '/';
      }
    }, 1000);
  }

  _stopIdleTimer() {
    if (_idleintervalHandler !== undefined) {
      clearInterval(_idleintervalHandler);
    }
  }


  _delayAcceptButton() {
    var btnDisableTime = 2;
    this._intervalHandler = setInterval(() => {
      btnDisableTime--;
      if(btnDisableTime == 0){
        $("#slideshow-btn-print").removeClass("slideshow-btn-disabled");
        $("#slideshow-btn-popup").removeClass("slideshow-btn-disabled");
        clearInterval(this._intervalHandler);
      }
    }, 1000);
  }

  _renderHTMLPrint() {
    let $printHTMLContainer = '';
    if(localStorage.getItem("printer_type") !== undefined){
      this._printertype = localStorage.getItem("printer_type");
    }
    if(this._printertype == 'RECEIPT'){
      const formData = this.$el.find('#tbl-receipt-sign-slide-form-data').html();
      $printHTMLContainer = $('#print-container').html(printTharmalHTMLTemplate($.extend({}, this._location, this._slideshow, {photoHost: this._photoHost})));
      $printHTMLContainer.find('#print-form-data').html(formData);
      if (this._location.module_qr_code === 1) {
        $printHTMLContainer.find('#qrcode').html('<img src="' + this._qrcode.qrcodeimage + '">');
        $printHTMLContainer.find('#qrcode_instruction').html('<span style="font-size:8px"><strong>'+this._qrcode.qr_code_instructions+'</strong></span>');
      }
    }
    else {
      if (this._location.module_qr_code === 1) {
        const formData = this.$el.find('#tbl-sign-slide-form-data').html();
        $printHTMLContainer = $('#print-container').html(printqrHTMLTemplate($.extend({}, this._location, this._slideshow, {photoHost: this._photoHost})));
        $printHTMLContainer.find('#print-form-data').html(formData);
        $printHTMLContainer.find('#qrcode').html('<img width="200" src="' + this._qrcode.qrcodeimage + '">');
        $printHTMLContainer.find('#qrcode_instruction').html('<h3>'+this._qrcode.qr_code_instructions+'</h3>');
      }else if (this._location.printout_landscape_mode === 1) {
        const formData = this.$el.find('#sign-slide-form-landscape-data').html();
        $printHTMLContainer = $('#print-container').html(printKIOSKLandscapeHTMLTemplate($.extend({}, this._location, this._slideshow, {photoHost: this._photoHost})));
        $printHTMLContainer.find('#print-form-data').html(formData);
      }else{
        const formData = this.$el.find('#tbl-sign-slide-form-data').html();
        $printHTMLContainer = $('#print-container').html(printHTMLTemplate($.extend({}, this._location, this._slideshow, {photoHost: this._photoHost})));
        $printHTMLContainer.find('#print-form-data').html(formData);
      }
    }
    this._pdfdoc = $printHTMLContainer;
  }

  _renderHTMLFormData() {
    let ret = '';
    let dl1 = '<dl class="dl-horizontal form-data-dl1">';
    let dl2 = '<dl class="dl-horizontal form-data-dl2">';
    let isEmpty = true;
    const formData = this._slideshow.getFormData();
    let i = 0;
    Object.keys(formData).forEach(field => {
      if (field === "form_field_id_scan") return;
      if(!this._moduleUniqueIdentifier){
        if (field === "unique_identification_number") return;
      }
      if (field === 'qrcode') return;
      if (field === 'label_location_id') return;
      if (field === 'label_exist_code') return;
      if (field === 'unique_identifier_label_exist') return;
      if (field === 'form_field_signature_id') return;
      const value = formData[field];
      if (isEmpty && value !== '') isEmpty = false;
      let label_name = '';
      if(this._moduleUniqueIdentifier && field === 'unique_identification_number'){
        if($("#unique_identifier_label_exist").val() == 1){
          return;
        }
        label_name = lang.get(this._uniqueIdentifierLabel);
      }else{
        label_name = lang.get(field);
      }
      if (i % 2 === 0)
        ret += '<tr><td width="50%">'+dl1;
      else
        ret += '<td width="50%">'+dl2;
      ret += '<dt style="font-size:22px; font-weight:bold">' + label_name + '</dt><dd style="font-size:22px;">' + value + '</dd>';
      if (i % 2 === 0)
        ret += "</dl></td>";
      else
        ret += "</dl></td></tr>";
      i += 1;
    });

    if (isEmpty) {
      ret = '<p>' + lang.get('sign_empty_form') + '</p>';
    }
    this.$el.find('#tbl-sign-slide-form-data').html(ret);
  }

  _renderTharmalHTMLFormData() {
    let ret = '';
    let isEmpty = true;
    const formData = this._slideshow.getFormData();
    let i = 0;
    Object.keys(formData).forEach(field => {
      if (field === "form_field_id_scan") return;
      if(!this._moduleUniqueIdentifier){
        if (field === "unique_identification_number") return;
      }
      if (field === 'qrcode') return;
      if (field === 'label_location_id') return;
      if (field === 'label_exist_code') return;
      if (field === 'unique_identifier_label_exist') return;
      if (field === 'form_field_signature_id') return;
      const value = formData[field];
      if (isEmpty && value !== '') isEmpty = false;
      let label_name = '';
      if(this._moduleUniqueIdentifier && field === 'unique_identification_number'){
        if($("#unique_identifier_label_exist").val() == 1){
          return;
        }
        label_name = lang.get(this._uniqueIdentifierLabel);
      }else{
        label_name = lang.get(field);
      }
      
      ret+= '<tr><td width="45%" style="font-size:20px; font-weight:bold padding-bottom: 10px; padding-top:10px;">';
      ret+= label_name+ ': </td><td width="55%" style="font-size:20px; padding-bottom: 10px; padding-top:10px;">'+ value+ '</td>';
      ret += "</tr>";
      i += 1;
    });

    if (isEmpty) {
      ret = '<p>' + lang.get('sign_empty_form') + '</p>';
    }
    this.$el.find('#tbl-receipt-sign-slide-form-data').html(ret);
  }

  _disableAcceptButton() {
    $("#slideshow-btn-print").addClass("slideshow-btn-disabled");
    $("#slideshow-btn-popup").addClass("slideshow-btn-disabled");
  }

  _renderLandscapeHTMLFormData() {
    let ret = '';
    let dl1 = '<dl class="dl-horizontal form-data-dl1">';
    let dl2 = '<dl class="dl-horizontal form-data-dl2">';
    let isEmpty = true;
    const formData = this._slideshow.getFormData();
    let i = 1;
    Object.keys(formData).forEach(field => {
      if (field === "form_field_id_scan") return;
      if(!this._moduleUniqueIdentifier){
        if (field === "unique_identification_number") return;
      }
      if (field === 'qrcode') return;
      if (field === 'label_location_id') return;
      if (field === 'label_exist_code') return;
      if (field === 'unique_identifier_label_exist') return;
      if (field === 'form_field_signature_id') return;
      const value = formData[field];
      if (isEmpty && value !== '') isEmpty = false;
      let label_name = '';
      if(this._moduleUniqueIdentifier && field === 'unique_identification_number'){
        if($("#unique_identifier_label_exist").val() == 1){
          return;
        }
        label_name = lang.get(this._uniqueIdentifierLabel);
      }else{
        label_name = lang.get(field);
      }
      if (i % 3 === 1)
        ret += '<tr><td width="33%">'+dl1;
      else
        ret += '<td width="33%">'+dl2;
      ret += '<dt><span>' + label_name + ': </span>' + value + '</dt>';;
      if (i % 3 !== 0)
        ret += "</dl></td>";
      else
        ret += "</dl></td></tr>";
      i += 1;
    });

    if (isEmpty) {
      ret = '<p>' + lang.get('sign_empty_form') + '</p>';
    }
    this.$el.find('#sign-slide-form-landscape-data').html(ret);
  }

  _renderLandscapeHTMLPrint() {
    let $printContainer = $('#print-container').html(printLandscapeHTMLTemplate($.extend({}, this._location, this._slideshow, {photoHost: this._photoHost})));
    const formData = this.$el.find('#sign-slide-form-landscape-data').html(); // make sure _renderFormData is called before _renderPrint, or this fails
    $printContainer.find('#print-form-data').html(formData);

    //Ajax call to get QR code
    var qr_code = '';
    if (this._location.module_qr_code === 1) {
      $.ajax({
        method: 'POST',
        url: 'slideshow/getqrcode',
        async: false,
        dataType: 'json',
        data: {
          'locationId': this._locationId,
          'name': $('#form_field_name').val(),
          'lpnumber': $('#form_field_registration_number').val()
        },
        success: function (res) {
          qr_code = res;
          qr_code.qr_code_instructions = lang.get('qr_code_instructions');
          $('#qrcode').html('<img src="' + res.qrcodeimage + '">');
          $('#qrcode_text').val(res.qrcode);
          $('#qrcode_instruction').html('<h3>'+lang.get('qr_code_instructions')+'</h3>');
        },
      });
    }
    this._qrcode = qr_code;
    this._pdfdoc = $printContainer;
    const trackId = this._slideshow.getTrackId();
    //Ajax Call to get the document and its length
    var url22 = window.location.toString();
    var res = url22.split('#');
    var result = "";
    var urlbreak = res[0].split("/");

    if (urlbreak[urlbreak.length - 1] === 'slideshow') {
      var urltocall = res[0] + '/getdocument?trackid='+trackId;
    }
    if (urlbreak[urlbreak.length - 1] === '') {
      var urltocall = res[0] + 'getdocument?trackid='+trackId;
    }

    $.ajax({
      async: false,
      type: "GET",
      url: urltocall,
      cache: false,
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      data: {},
      success: function (response) {


        if (response.document_name !== '') {
          var removeEmptypage = 0;
          var ii = 1;
          $.each(response, function (key, value) {

            var url = value.document_name;

// Loaded via <script> tag, create shortcut to access PDF.js exports.
            var pdfjsLib = window['pdfjs-dist/build/pdf'];
            pdfjsLib.workerSrc = "/path/to/pdf.worker.js";
            pdfjsLib.getDocument(url).promise
              .then(function (pdf) {

                // Get div#container and cache it for later use
                var d1 = document.getElementById('container2');
                d1.insertAdjacentHTML('afterend', '<div id="container' + ii + '"></div>');
                var container = document.getElementById("container" + ii);

                // Loop from 1 to total_number_of_pages in PDF document

                for (var i = 1; i <= pdf.numPages; i++) {
                  // Get desired page
                  pdf.getPage(i).then(function (page) {

                    var scale = 1.15;
                    var viewport = page.getViewport(scale);
                    //viewport.height = 792;
                    //viewport.width = 900;
                    var div = document.createElement("div");

                    // Set id attribute with page-#{pdf_page_number} format
                    div.setAttribute("id", "page-" + (page.pageIndex + 1));

                    // This will keep positions of child elements as per our needs
                    div.setAttribute("style", "position: relative");

                    // Append div within div#container
                    container.appendChild(div);

                    // Create a new Canvas element
                    var canvas = document.createElement("canvas");

                    // Append Canvas within div#page-#{pdf_page_number}
                    div.appendChild(canvas);

                    var context = canvas.getContext('2d');
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;

                    var renderContext = {
                      canvasContext: context,
                      viewport: viewport
                    };

                    // Render PDF page
                    page.render(renderContext);

                  });
                }
              });


            ii++;
          });


        }
      }
    });
  }
};
